/* ============
 * ExciseEntry Transformer
 * ============
 */

import Transformer from './transformer';

export default class ExciseReportTransformer extends Transformer {

  static fetch(entry) {
    return {
      group: entry.title,
      description: entry.description,
      totalQuantity: entry.total_quantity,
      unitType: entry.unit_type,
      totalVolume: entry.total_volume,
      exciseEntries: entry.excise_entries,
    };
  }

  static send(entry) {
    return {
      id: entry.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/exciseReport.js